













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class MoreLink extends Vue {
  @Prop({ required: true })
  href: string
}
